// extracted by mini-css-extract-plugin
module.exports = {"share-icon":"ShareButton_share-icon__25HYw"};